import { companiesApi } from 'src/api/companiesApi';
import type { WazuhClientOrganization } from 'src/mindtime/hooks/useWazuhScope';

/** Same child-companies source as `/companies` (`companiesApi.getChildCompaniesByParentId`). */
export const fetchWazuhClientCompanies = async (
  parentId: string,
  search = '',
  page = 0,
  pageSize = 25
): Promise<WazuhClientOrganization[]> => {
  const response = await companiesApi.getChildCompaniesByParentId({
    parentId,
    page,
    pageSize,
    search,
  });

  const orgsArray = response?.data?.data ?? [];
  return (Array.isArray(orgsArray) ? orgsArray : [])
    .map((org: { id?: string; name?: string }) => ({
      id: String(org.id ?? ''),
      name: String(org.name ?? ''),
    }))
    .filter((org) => org.id && org.name);
};
